import { logger } from 'dd-client/site/common/utils/logger/logger';
import config from '../config';

const getConfig = (path: string, defaultValue: any = undefined): any => {
  const separator = '.';

  try {
    return path.replace('[', separator).replace(']', '').split(separator).reduce(
      (accumulator: Record<string, any>, currentValue: string) => accumulator[currentValue],
      config,
    );
  } catch (error) {
    logger.error('getConfig error', { error });
    return defaultValue;
  }
};

export {
  getConfig,
};
